import { getGlobalParamsOptionsAsync } from '@/utils/common.js'

export const searchFormConfig = {
  formItems: [
    {
      field: 'logType',
      type: 'select',
      label: 'terminal.log-type',
      options: [],
      isResolveGlobalParams: true,
      handler: () =>
        getGlobalParamsOptionsAsync('traceTypeList', {
          isNeedPreFix: false
        }),
      otherOptions: {}
    },
    {
      field: 'remark',
      type: 'input',
      label: 'general.remark'
    },
    {
      field: 'creationDate',
      type: 'datepicker',
      label: 'general.creation-date',
      otherOptions: {
        type: 'daterange',
        format: 'YYYY-MM-DD',
        valueFormat: 'YYYY-MM-DD'
      },
      dateFieldName: ['startDateTime', 'endDateTime']
    }
  ]
}
